/**
 * One error dialog for the whole panel.
 *
 * A screen reports the error and stops there: `AppErrorDialog`, mounted once in
 * `App.js`, is the thing that shows it. No screen owns dialog state, an
 * `<ErrorDialog>` in its render, or a close handler of its own.
 *
 * The channel is a DOM event and not React context on purpose: the callers are
 * `catch` blocks in class components, service helpers and hooks alike, and a
 * plain function they can import reaches all three without threading a prop or
 * a context down every tree that owns a fetch.
 */

export const API_ERROR_EVENT = 'bsfood:api-error';

const DEFAULT_MESSAGE = 'Si è verificato un errore. Operazione non riuscita';

function dispatch(message, title) {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(API_ERROR_EVENT, {
      detail: { message: message || DEFAULT_MESSAGE, title: title || null },
    }),
  );
}

/**
 * Shows the message an `ApiError` carries. The api modules have already chosen
 * that sentence — the server's own, the endpoint's, or the generic one — so
 * there is nothing left here to decide.
 */
export function reportApiError(error, title = null) {
  dispatch(error && error.message, title);
}

/**
 * Shows a message the screen wrote itself: a failed validation, a rule that
 * has nothing to do with a request. Same dialog, so the operator meets one
 * kind of error box and not two.
 */
export function reportError(message, title = null) {
  dispatch(message, title);
}
